export function urlForSpace(spaceId: string): string {
	return `/api/v1/${spaceId}`;
}
